<template>
    <print-layout title="Current Flyer">
        <page-header>
            <template #title>Current Flyer</template>
            <template #actions>
                <jet-button v-if="flyer" type="button" class="h-7 leading-none" @click="downloadCurrentFlyer()">
                    Download Flyer
                </jet-button>
            </template>
        </page-header>

        <div class="px-8 mt-2">
            <iframe v-if="flyer" :src="fullFilepath" style="width: 100%; height: 85vh; border: none;"></iframe>
            <div v-else>No Current Flyer</div>
        </div>
    </print-layout>
</template>

<script>

import PrintLayout from '@/Layouts/PrintLayout.vue';
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import PageHeader from '@/Layouts/partials/PageHeader.vue';

export default {
    components: {
        PrintLayout,
        PageHeader,
        JetButton,
        JetTertiaryButton,
    },

    props: ['flyer'],

    methods: {
        downloadCurrentFlyer() {
            location.href = route('settings.flyers.download-current')
        },
    },

    computed: {
        fullFilepath () {
            if (this.flyer) return '/storage/' + this.flyer.filepath;
            else return null;
        }
    }
}
</script>
